var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206 235.1",
    style: {
      enableBackground: "new 0 0 206 235.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,166.2c0,7.2-5.8,13-13,13s-13-5.8-13-13c0-4.7,2.5-8.8,6.2-11.1c0.4-0.3,0.9-0.5,1.4-0.7 c1.6-0.8,3.5-1.2,5.4-1.2C20.2,153.2,26,159,26,166.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "6.1,59.9 106.1,0 205.7,59.9 206,175.1 105.6,235.1 92.2,226.9 91.9,116.3 91.9,116.3 91.9,107.7  141.3,79 177.6,59 164.5,51.3 107.8,16.1 21.2,67.8 20.9,155.9 6.2,155.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "48.1,200.4 48.3,84.4 124,40.4 110.9,32.2 35.1,77.3 35.1,191.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.1,217.7 77.1,101 152.3,57.4 137.8,48.7 62.7,93.4 62.7,208.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88c3340549caad04b7c6aed279ff3652.svg";
export { ForwardRef as ReactComponent };